import { EventEmitter, Injectable, inject } from '@angular/core';
import { CustomProductSettingsRequest } from '@shared/models';
import { CustomProductCalculations } from '@shared/models/custom-product-calculations';
import { Observable, tap } from 'rxjs';
import { ClubHubDataService } from './clubhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class UserCustomProductSettingsService {
  private readonly clubHubDataService = inject(ClubHubDataService);

  /** Fired when the user updates their custom product settings. */
  public readonly settingsChange = new EventEmitter<void>();

  public getUserCustomProductSettings(): Observable<CustomProductCalculations> {
    return this.clubHubDataService.get<CustomProductCalculations>('CustomProductSettings/Users');
  }

  public updateUserCustomProductSettings(request: CustomProductSettingsRequest): Observable<void> {
    return this.clubHubDataService.post<never>('CustomProductSettings/Users', request).pipe(tap(() => this.settingsChange.emit()));
  }
}
